import classNames from "classnames";
import { Button, Label, Typography } from "components/atoms";
import { useNavigate } from "react-router-dom";
import "./index.scss";

interface TestData {
  homeworkName: string;
  dueDate: string;
  dateCompleted: string;
  status: string[];
}

export const AppealTableMobile = () => {
  const navigate = useNavigate();
  const data: TestData[] = [
    {
      homeworkName: "FSQ Drill: Biochemistry I - Biomolecules and Enzymes",
      dueDate: "MM/DD/YY 00:00",
      dateCompleted: "Not Completed",
      status: ["Past Due"],
    },
    {
      homeworkName: "MCAT Biology Passage 3 - Enzymes III",
      dueDate: "MM/DD/YY 00:00",
      dateCompleted: "Not Completed",
      status: ["Incompleted"],
    },
    {
      homeworkName: "MCAT Biology Passage 78 - Enzymes IV",
      dueDate: "MM/DD/YY 00:00",
      dateCompleted: "MM/DD/YY 00:00",
      status: ["Late"],
    }
  ];

  const getMatchColor = (status: string) => {
    switch (status) {
      case "Past Due":
      case "Incompleted":
      case "Late":
        return "red";
      case "Completed":
        return "green";
      default:
        return "gray";
    }
  };

  return (
    <div className={classNames("appeal-mobile-wrapper")}>
      {data.map((item: any, index: number) => (
        <div
          key={index}
          className={classNames({
            "appeal-mobile-items": true,
            "highlight": index % 2 === 0
          })}
        >
          <div>
            <Typography variant="h8Med" label="Homework Name" />
            <Typography
              styles="appeal-mobile-link-text"
              variant="h8Med"
              label={item.homeworkName}
            />
          </div>
          <div>
            <Typography variant="h8Med" label="Due Date" />
            <Typography
              styles="appeal-mobile-normal-text"
              variant="h8Book"
              label={item.dueDate}
            />
          </div>
          <div>
            <Typography variant="h8Med" label="Date Completed" />
            <Typography
              styles="appeal-mobile-normal-text"
              variant="h8Book"
              label={item.dateCompleted}
            />
          </div>
          <div>
            <Typography variant="h8Med" label="Status" />
            <div className="status-wrapper">
              {item["status"].map((value: any, index: number) => (
                <Label
                  key={index}
                  backgroundColor={getMatchColor(value)}
                  label={value}
                />
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
